import { Card, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import { hasKey, hasLanguageKeyAndStringArrayValue } from '@hubertai/screening-question-types';
import type { TChatCollection } from 'types/scores.types';

interface Props extends ComponentProps<'div'> {
  condition: boolean;
  collection: TChatCollection;
}

const ConditionedQuestionText = ({ condition, collection, ...props }: Props) => {
  const [questionText, setQuestionText] = useState<string>('');

  useEffect(() => {
    const question = collection.question;
    const lang =
      collection.expectedLanguage && collection.expectedLanguage.length ? collection.expectedLanguage[0] : null;
    if (question && lang && hasKey(question.text, lang) && hasLanguageKeyAndStringArrayValue(question.text, lang)) {
      setQuestionText(question.text[lang]?.join(' '));
    }
  }, [collection]);

  if (!condition) return null;

  return (
    <div {...props} className={clsx('flex flex-col items-start justify-start gap-2')}>
      <div className={clsx('w-full', 'flex items-start justify-start', 'max-w-[80%] p-[1px]')}>
        <Card>
          <Text as="div" size="2" color="gray">
            <div dangerouslySetInnerHTML={{ __html: questionText }} />
          </Text>
        </Card>
      </div>
    </div>
  );
};

export default ConditionedQuestionText;
